import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en: {
      sidebar: {
        settings: 'Settings',
        account: 'Account',
        billing: 'Billing',
        export: 'Export Faves',
      },
      userDashboard: 'User Dashboard',
      adminDashboard: 'Admin Dashboard',
      mail: 'info@allmyfaves.com',
      blogPost: 'Post',
      admins: 'Admins',
      usernameMinimumLength: 'The username should be longer than 3 characters',
      validUsername: 'Please provide a valid username address.',
      missingValue: 'Required field',
      logout: 'Log out',
      loginBtn: 'Log in',
      mostPopular: 'Most Popular',
      weekley: 'Weekly Faves',
      userCard: {
        privateProfile: 'Private profile',
        publicProfile: 'Public profile',
        favorite: 'favorite',
        bookmark: 'bookmark',
        share: 'share',
      },
      account: {
        upload: 'Upload a new Photo...',
        username: "Username",
        mail: 'E-mail',
        privateAccount: 'Keep my account private',
        notifications: 'Receive notifications',
        updates: 'Receive updates about All My Faves',
        deleteAccount: 'Delete Account',
        text1: 'Visualize',
        text2: 'your',
        text3: 'Bookmarks',
      },
      bookmarklet: {
        title: 'Add a bookmark',
        titleRequired: 'Title Required',
        addNewTab: 'Add New Tab',
        addBookmark: 'Add bookmark',
        drag: 'Drag this Button to your Bookmarks Bar',
        install: 'To install the "Fave It" button:',
        installBookmarkBtn: 'To install the "Add it to your bookmarks" button:',
        installex1: 'Display your Bookmarks by clicking the Ctrl + Shift + B on your keyboard',
        installex2: 'Drag the "Fave It" button to your Bookmarks bar',
        installex3: 'When you are browsing the web, press the "Fave It" button to bookmark a website in your account',
        installex4: 'Drag the "Add it to your bookmarks" button to your Bookmarks bar',
        installex5: 'When you are browsing the web, press the "Add it to your bookmarks" button to bookmark a website in your account',
      },
      login: {
        title: 'Welcome back to',
        email: 'Email',
        username: 'Username',
        password: 'Password',
        requiredField: 'Required field.',
        minLengthUsername: 'The username should be minimum 3 characters.',
        minLengthPassword: 'The password should be minimum 5 characters.',
        forgotUsername: 'Forgot username?',
        forgotPassword: 'Forgot password?',
        loginBtn: 'Login',
        noAccount: "Don't have an account?",
        getStarted: 'Get started',
        goToLogin: 'Go to Login Page',
        confirmedAccount: 'Account has been confirmed',
      },
      faves: {
        favesByCountryTitle: 'Faves By Country',
        hide: 'Hide',
        show: 'Show',
        topFavesTitle: 'Top Faves',
      },
      // A MyFaves page the API will not serve (PageUnavailable.vue). English
      // only for now; ru and es fall back to it.
      pageUnavailable: {
        private: {
          eyebrow: 'Private page',
          title: 'This page is private',
          body: 'Only its owner can see it right now.',
          pitch: 'Want a page like this that anyone can visit?',
          cta: 'Create your public page',
          isThisYours: 'Is this your page? Sign in to see it',
        },
        notFound: {
          eyebrow: 'Nothing here yet',
          title: 'No one has this page yet',
          body: "There's no All My Faves page at this address. Check the spelling, or make it yours.",
          pitch: 'Put your favorite sites on a page anyone can visit',
          cta: 'Create your page',
        },
        perks: {
          address: 'Your own allmyfaves.com address',
          unlimited: 'Unlimited tabs and sites',
          noAds: 'No ads, and your logos first in line',
        },
        ctaSignedIn: 'Make my page public',
        goToMyPage: 'Go to my page',
        backHome: 'Back to the homepage',
      },
      limitPopup: {
        member: {
          title: "You've made this page your own",
          countsTabs: '{tabs} tabs and {sites} sites, all picked by you.',
          countsTabsOnly: '{tabs} tabs, all set up by you.',
          countsSites: '{sites} sites, all picked by you.',
          countsNone: 'Everything on this page was picked by you.',
          ask: "We'd love to keep it growing with you. To keep adding more, we ask long-time members like you to support AllMyFaves; it's what keeps it running for everyone. Your page and everything on it stays yours either way.",
          cta: 'Keep growing my page',
        },
        publicPage: {
          title: 'A public page comes with a paid plan',
          body: 'Your page is private, so only you can see it. On a paid plan you can share it at your own All My Faves address, alongside unlimited tabs and sites, no ads, and logo priority for the sites you add.',
        },
        follow: {
          title: 'Do-follow links come with a paid plan',
          body: 'On a paid plan the links on your public page pass search credit to the sites they point to. You also get unlimited tabs and sites, logos for your new sites first, and no ads.',
        },
        tabFull: {
          title: 'This tab is full: {count} sites',
          body: 'Tabs hold up to {count} sites so your page stays easy to scan. Start a new tab for the rest.',
          cta: 'Create a new tab',
        },
        price: {
          perMonth: '${amount}/month',
          billedYearly: 'billed yearly',
          orMonthly: 'or ${amount} monthly',
          refund: 'full refund within 14 days',
        },
        cta: 'Go unlimited',
        notNow: 'Not now',
        close: 'Close',
        billingReason: {
          unlimited: 'Unlimited tabs and sites. Pick the plan that suits you.',
          follow: 'Do-follow links, plus unlimited tabs and sites. Pick the plan that suits you.',
        },
      },
      userTopTabs: {
        addBtn: 'Add your own faves',
        cellTitle: 'Site Details',
        validUrl: 'Url is not valid!',
        delete: 'delete',
        logo: 'logo',
        save: 'save',
        mostPopularSiteTitle: 'Add new Site to Most Popular List',
        sitetitle: 'Site',
        position: 'Position',
        close: 'Close',
        tabDetails: 'Tab details',
        private: 'private',
        public: 'public',
        share: 'share',
        copy: 'copy link',
        settings: 'Setting',
        settingModalTitle: 'Add New Setting',
        key: 'Key',
        value: 'Value',
        description: 'Description',
        upgradePlan: 'Upgrade your plan to add more tabs',
        changePlan: 'See our plans'
      },
      forgotPassword: {
        title: 'Forgot Password',
        forgotBtn: 'FORGOT PASSWORD',
      },
      resetPassword: {
        title:'Reset Password',
        resetBtn: 'RESET PASSWORD',
        passwordMinLength: 'The password should be longer than 8 characters',
      },
      register: {
        title: 'Create your AllMyFaves Account',
        email: 'Email',
        username: 'Username',
        password: 'Password',
        requiredField: 'Required field',
        registerBtn: 'Create account',
        haveAccount: 'Have an account?',
        signInBtn: 'Sign in',
        acceptTC: 'I accept',
        pleaseAcceptTC: 'Please accept Terms&Conditions',
        termsConditions: 'T&C',
        visualBookmarks: 'One page, every site',
        visualBookmarksTxt1: 'Your bookmarks as logos you recognize, not a list of text links.',
        visualBookmarksTxt2: 'Our visual bookmarking tool allows you to add and manage all your favorite sites in one place.',
        discoverMore: 'Chosen by editors',
        discoverMoreTxt: 'Every site here was picked by a person, not an algorithm.',
        discoverMoreTxt1: 'AllMyFaves offers a curated selection of awesome websites across a wide range of topics,',
        discoverMoreTxt2: 'so you can easily find something new to love.',
        faveIt: 'Fave It',
        faveItTxt: 'Save the page you are reading with a single click.',
        faveItTxt1: 'use AllMyFaves "Fave It" button to quickly and easily save your favorite pages.',
        faveItTxt2: 'Access them anytime, anywhere.',
        everywhere: 'Anywhere you sign in',
        everywhereTxt: 'Your faves follow you to any computer, phone, or tablet.',
        everywhereTxt1: 'Our tool is available on any computer, smartphone, or tablet,',
        everywhereTxt2: 'so you can access your favorite sites no matter where you are.',
        invalidEmail: 'Email is not valid',
        minLengthUsername: 'The username should be minimum 3 characters.',
        minLengthPassword: 'The password should be minimum 5 characters.',
      },
      aboutUs: {
        eyebrow: 'About',
        pageTitle: 'Chosen by people, since 2006',
        lede: 'All My Faves is a starting page. Open a category, run your eye down it, and go \u2014 no query to phrase, no results page to read, no working out which of ten links is the one you actually meant.',

        whyTitle: 'Why search?',
        whyBody1: 'Search is good at answering a question you can already put into words. It is much worse at the other thing people do online, which is look around. Most of what you open in a day is not a question at all \u2014 it is somewhere you already know, or somewhere you would like if someone showed it to you.',
        whyBody2: 'So the site is a page of links, sorted into the categories people actually use, and every logo is one click away. That was the whole idea at the start and it has not changed since.',

        handTitle: 'Picked by hand',
        handBody1: 'Every site here was put there by a person who looked at it first. Nothing is added by a crawler and nothing is ordered by an algorithm. Some placements are paid for, and those carry a small Ad mark so you can tell which ones they are.',
        handBody2: 'Twenty years on, that is an easier case to make than it was at the beginning. A great deal of the web is now written to rank rather than to be read. A short list someone stands behind is worth more than a long one nobody checked.',

        storyTitle: 'Where it came from',
        storyBody1: 'In 2006 Shachar Pessis got tired of how much work it took to get anywhere online \u2014 typing addresses from memory, digging through a bookmark list that had long since stopped being useful, or asking whichever friend happened to know the good sites.',
        storyBody2: 'He said as much to his brother Roy, and between them they sketched out what became All My Faves: one page of the sites people actually use, arranged so you could find something without already knowing its name. It has been put together by hand ever since.',

        yoursTitle: 'Make it your own',
        yoursBody: 'My Faves gives you your own version of the page \u2014 your sites, your categories, in the order you want them, waiting in any browser you sign in to.',
        yoursLink: 'Start your own page',

        latestTitle: 'The Latest',
        latestBody: 'The row at the top of the homepage holds the newest sites to pass review. Nothing that has been featured is thrown away when the next batch arrives \u2014 it all stays in the archive.',
        latestLink: 'Browse the archive',

        nextTitle: 'Anything else?',
        faqCard: 'Frequently asked questions',
        faqCardBody: 'How the page works, accounts, and what to do when something breaks.',
        contactCard: 'Contact us',
        contactCardBody: 'Feedback, a broken link, a correction, or a partnership.',
        advertiseCard: 'Advertise with us',
        advertiseCardBody: 'Take a position in any category on the homepage.',
      },
      press: {
        pressPageTitle: 'Press Room'
      },
      bookmark: {
        faveBookmarkPageTitle: 'The Bookmark',
        saveBookmark: 'Easily Save Your Faves',
      },
      contact: {
        title: 'Contact Us',
        subtitle1: 'Your opinion means a great deal to us. If you have a comment, suggestion, complaint or recommendation of a site/category, Please mail us at',
        subtitle2: 'or fill out the form below.',
        checkboxTitle: 'How did you hear about us?',
        checkbox: {
          search: 'Search',
          referringSite: 'Reffering Site',
          tv: 'Television',
          radio: 'Radio',
          newspaper: 'Newspaper',
          world: 'World Of Mouth'
        },
      },
      footer: {
        titleSection1: 'All My Faves',
        aboutUs: 'About Us',
        advertise: 'Advertise With Us',
        join: 'Join',
        tellAFriend: 'Tell A Friend',
        press: 'Press',
        blog: 'Blog',
        adminArea: "Admin Area",
        support: 'Support',
        faq: 'FAQ',
        wantMore: 'Want More?',
        contactUs: 'Contact Us',
        oldWebsite: 'Old Website',
        downloadApp: "Download the App",
        privacy: 'Privacy Policy',
        terms: 'Terms of Use',
        rights: 'All rights reserved.',
      },
      navbar: {
        TYPE_TOP_FAVES: 'Top Faves',
        TYPE_GAMES: 'Top Games',
        TYPE_BLOGS: 'Top Blogs',
        TYPE_CATEGORY: 'Categories',
        shop: 'Shop',
        sports: 'Sports',
        shopping: 'Shopping',
        apparel: 'Apparel',
        homeElectronics: 'Home & Electronics',
        discover: 'Discover',
        weeklyFaves: 'Weekly Faves',
        weeklyGames: 'Weekly Games',
        favesByCountry: 'Faves By Country',
        blog: 'Blog',
        settings: 'Settings',
        myFaves: 'MyFaves',
        gifts: 'Gifts',
        entertainment: 'entertainment',
        apps: 'Apps',
        instagram: 'Instagram',
        giftguide: 'Gift Guide',
        faveButton: 'Fave It Button',
        faq: 'FAQ',
        sideBarHome: 'Navigation',
        home: 'Home',
        profile: 'Profile',
        adminMenu: 'Admin Menu',
        categories: 'Categories',
        blogs: 'Blogs',
        biz: 'Business',
        edu: 'Education',
        ent: 'Entertainment',
        kids: 'Kids',
        npo: 'NPO',
        travel: 'Travel',
        tvonline: 'Tv Online',
        xmas: 'Xmas',
      },
    },
    ru: {
      sidebar: {
        settings: 'настройки',
        account: 'учетная запись',
        billing: 'выставление счетов',
        export: 'экспортные фавориты',
      },
      userDashboard: 'панель пользователя',
      adminDashboard: 'панель администратора',
      mail: 'info@allmyfaves.com',
      blogPost: 'Post',
      admins: 'админы',
      missingValue: 'Обязательное поле',
      usernameMinimumLength: 'Имя пользователя должно быть длиннее 3 символов.',
      validUsername: 'Пожалуйста, укажите действующий адрес пользователя.',
      logout: 'Выйти',
      mostPopular: 'Самый популярный',
      weekley: 'Еженедельные лица',
      userCard: {
        privateProfile: 'Личный профиль',
        publicProfile: 'Общедоступный профиль',
        favorite: 'любимый',
        bookmark: 'закладка',
        share: 'Поделиться',
      },
      account: {
        upload: 'Загрузить новую фотографию...',
        username: "Имя пользователя",
        mail: 'Эл. почта',
        privateAccount: 'Держите мою учетную запись приватной',
        notifications: 'Получать уведомления',
        updates: 'Получать обновления обо всех моих любимых',
        deleteAccount: 'Удалить аккаунт',
        text1: 'Визуализировать',
        text2: 'ваш',
        text3: 'Закладки',
      },
      bookmarklet: {
        title: 'Добавить закладку',
        titleRequired: 'Требуется название',
        addNewTab: 'Добавить новую вкладку',
        addBookmark: 'Добавить закладку',
        drag: 'Перетащите эту кнопку на панель закладок',
        install: 'Чтобы установить кнопку «Добавить в избранное»:',
        installex1: 'Отобразите свои закладки, нажав Ctrl + Shift + B на клавиатуре',
        installex2: 'Перетащите кнопку «Добавить в избранное» на панель закладок.',
        installex3: 'При просмотре веб-страниц нажмите кнопку «Добавить в избранное», чтобы добавить веб-сайт в закладки в своей учетной записи.',
      },
      login: {
        title: 'Добро пожаловать обратно в',
        email: 'Эл. адрес',
        username: 'Username',
        password: 'имя пользователя',
        requiredField: 'Обязательное поле.',
        minLengthUsername: 'Имя пользователя должно состоять минимум из 3 символов..',
        minLengthPassword: 'Пароль должен состоять минимум из 5 символов..',
        forgotUsername: 'забыл имя пользователя?',
        forgotPassword: 'забыл пароль?',
        loginBtn: 'Авторизоваться',
        noAccount: "Нет учетной записи?",
        getStarted: 'Начать',
        goToLogin: 'Перейти на страницу входа',
        confirmedAccount: 'Аккаунт подтвержден',
      },
      faves: {
        favesByCountryTitle: 'Любимые страны',
        hide: 'Скрывать',
        show: 'Показать',
        topFavesTitle: 'Top Faves',
      },
      limitPopup: {
        member: {
          title: 'Эта страница по-настоящему ваша',
          countsTabs: 'Вкладок: {tabs}, сайтов: {sites}. Всё это выбрали вы.',
          countsTabsOnly: 'Вкладок: {tabs}. Всё это настроили вы.',
          countsSites: 'Сайтов на вашей странице: {sites}, и каждый выбрали вы.',
          countsNone: 'Всё на этой странице выбрали вы.',
          ask: 'Мы бы очень хотели, чтобы она росла и дальше. Чтобы добавлять больше, мы просим давних участников, таких как вы, поддержать AllMyFaves: именно это позволяет сайту работать для всех. Ваша страница и всё, что на ней, в любом случае остаются вашими.',
          cta: 'Продолжить наполнять страницу',
        },
        publicPage: {
          title: 'Публичная страница доступна на платном тарифе',
          body: 'Ваша страница приватная, её видите только вы. На платном тарифе ею можно делиться по собственному адресу на All My Faves, а вместе с этим вы получаете неограниченные вкладки и сайты, отсутствие рекламы и приоритет логотипов для добавленных сайтов.',
        },
        follow: {
          title: 'Do-follow ссылки доступны на платном тарифе',
          body: 'На платном тарифе ссылки на вашей публичной странице передают поисковый вес сайтам, на которые ведут. А ещё неограниченные вкладки и сайты, логотипы для новых сайтов в первую очередь и никакой рекламы.',
        },
        tabFull: {
          title: 'Эта вкладка заполнена: {count} сайтов',
          body: 'Во вкладке помещается до {count} сайтов, чтобы страницу было удобно просматривать. Создайте новую вкладку для остальных.',
          cta: 'Создать вкладку',
        },
        price: {
          perMonth: '${amount}/мес.',
          billedYearly: 'при оплате за год',
          orMonthly: 'или ${amount} помесячно',
          refund: 'полный возврат в течение 14 дней',
        },
        cta: 'Перейти на безлимит',
        notNow: 'Не сейчас',
        close: 'Закрыть',
        billingReason: {
          unlimited: 'Неограниченные вкладки и сайты. Выберите подходящий тариф.',
          follow: 'Do-follow ссылки, а также неограниченные вкладки и сайты. Выберите подходящий тариф.',
        },
      },
      userTopTabs: {
        addBtn: 'Добавьте своих любимых',
        cellTitle: 'Детали сайта',
        validUrl: 'URL недействителен!',
        delete: 'удалять',
        logo: 'логотип',
        save: 'спасти',
        mostPopularSiteTitle: 'Добавить новый сайт в список самых популярных',
        sitetitle: 'Сайт',
        position: 'Позиция',
        close: 'Закрывать',
        tabDetails: 'Детали вкладки',
        private: 'частный',
        public: 'общественный',
        share: 'Поделиться',
        copy: 'копировать ссылку',
      },
      forgotPassword: {
        title: 'Забыл пароль',
        forgotBtn: 'ЗАБЫЛ ПАРОЛЬ',
      },
      resetPassword: {
        title:'Сброс пароля',
        resetBtn: 'СБРОС ПАРОЛЯ',
        passwordMinLength: 'Пароль должен быть длиннее 8 символов.',
      },
      register: {
        title: 'Создайте свою учетную запись AllMyFaves',
        email: 'Эл. адрес',
        username: 'Имя пользователя',
        password: 'Пароль',
        requiredField: 'Обязательное поле',
        registerBtn: 'Создать аккаунт',
        haveAccount: 'Иметь аккаунт?',
        signInBtn: 'Войти',
        acceptTC: 'Я принимаю Я согласен',
        pleaseAcceptTC: 'Пожалуйста, примите Условия использования',
        termsConditions: 'T&C',
        visualBookmarks: 'Визуальные закладки',
        visualBookmarksTxt: 'Добавляйте и управляйте всеми своими закладками под одной крышей.',
        discoverMore: 'Узнайте больше',
        discoverMoreTxt: 'Найдите множество отличных веб-сайтов на любую тему.',
        faveIt: 'Fave It',
        faveItTxt: 'С легкостью сохраняйте избранное, используя кнопку «Добавить в избранное».',
        everywhere: 'Где угодно',
        everywhereTxt: 'Используйте его везде. На любом компьютере, смартфоне или планшете.',
      },
      aboutUs: {
        eyebrow: 'About',
        pageTitle: 'Chosen by people, since 2006',
        lede: 'All My Faves is a starting page. Open a category, run your eye down it, and go \u2014 no query to phrase, no results page to read, no working out which of ten links is the one you actually meant.',

        whyTitle: 'Why search?',
        whyBody1: 'Search is good at answering a question you can already put into words. It is much worse at the other thing people do online, which is look around. Most of what you open in a day is not a question at all \u2014 it is somewhere you already know, or somewhere you would like if someone showed it to you.',
        whyBody2: 'So the site is a page of links, sorted into the categories people actually use, and every logo is one click away. That was the whole idea at the start and it has not changed since.',

        handTitle: 'Picked by hand',
        handBody1: 'Every site here was put there by a person who looked at it first. Nothing is added by a crawler and nothing is ordered by an algorithm. Some placements are paid for, and those carry a small Ad mark so you can tell which ones they are.',
        handBody2: 'Twenty years on, that is an easier case to make than it was at the beginning. A great deal of the web is now written to rank rather than to be read. A short list someone stands behind is worth more than a long one nobody checked.',

        storyTitle: 'Where it came from',
        storyBody1: 'In 2006 Shachar Pessis got tired of how much work it took to get anywhere online \u2014 typing addresses from memory, digging through a bookmark list that had long since stopped being useful, or asking whichever friend happened to know the good sites.',
        storyBody2: 'He said as much to his brother Roy, and between them they sketched out what became All My Faves: one page of the sites people actually use, arranged so you could find something without already knowing its name. It has been put together by hand ever since.',

        yoursTitle: 'Make it your own',
        yoursBody: 'My Faves gives you your own version of the page \u2014 your sites, your categories, in the order you want them, waiting in any browser you sign in to.',
        yoursLink: 'Start your own page',

        latestTitle: 'The Latest',
        latestBody: 'The row at the top of the homepage holds the newest sites to pass review. Nothing that has been featured is thrown away when the next batch arrives \u2014 it all stays in the archive.',
        latestLink: 'Browse the archive',

        nextTitle: 'Anything else?',
        faqCard: 'Frequently asked questions',
        faqCardBody: 'How the page works, accounts, and what to do when something breaks.',
        contactCard: 'Contact us',
        contactCardBody: 'Feedback, a broken link, a correction, or a partnership.',
        advertiseCard: 'Advertise with us',
        advertiseCardBody: 'Take a position in any category on the homepage.',
      },
      press: {
        pressPageTitle: 'Press Room'
      },
      bookmark: {
        faveBookmarkPageTitle: 'Закладка',
        saveBookmark: 'Легко сохранять свои любимые',
      },
      contact: {
        title: 'Связаться с нами',
        subtitle1: 'Ваше мнение очень важно для нас. Если у вас есть комментарий, предложение, жалоба или рекомендация сайта / категории, напишите нам по адресу',
        subtitle2: 'или заполните форму ниже.',
        checkboxTitle: 'Откуда вы узнали о нас?',
        checkbox: {
          search: 'Поиск',
          referringSite: 'Ссылающийся сайт',
          tv: 'Телевидение',
          radio: 'Радио',
          newspaper: 'Газета',
          world: 'Мир рта'
        },
      },
      footer: {
        titleSection1: 'All My Faves',
        aboutUs: 'О нас',
        advertise: 'Разместить рекламу',
        join: 'Присоединиться',
        tellAFriend: 'Рассказать другу',
        press: 'Нажмите',
        blog: 'Блог',
        adminArea: "Админка",
        support: 'Служба поддержки',
        faq: 'FAQ',
        wantMore: 'Хочу больше?',
        contactUs: 'Связаться с нами',
        oldWebsite: 'Old Website',
        downloadApp: "Скачать приложение",
        privacy: 'Политика конфиденциальности',
        terms: 'Условия эксплуатации',
        rights: 'Все права защищены.',
      },
      navbar: {
        topFaves: 'Top Faves',
        shop: 'Магазин',
        shopping: 'Покупка',
        apparel: 'Одежда',
        homeElectronics: 'Дом и электроника',
        discover: 'Обнаружить',
        weeklyFaves: 'Еженедельные избранное',
        weeklyGames: 'Еженедельные игры',
        favesByCountry: 'Любимые страны',
        blog: 'Блог',
        settings: 'Настройки',
        myFaves: 'Мои любимые',
        interests: 'Добавить интересы',
        faveButton: 'Кнопка Fave It',
        faq: 'FAQ',
        sideBarHome: 'Навигация',
        home: 'Дом',
        profile: 'Профиль',
        adminMenu: 'Меню администратора',
      },
    },
    es: {
      sidebar: {
        settings: 'Ajustes',
        account: 'La Cuenta',
        billing: 'La facturación',
        export: 'Exportar Favoritos',
      },
      userDashboard: 'Panel de Usuario',
      adminDashboard: 'Panel de Administración',
      mail: 'info@allmyfaves.com',
      blogPost: 'Post',
      admins: 'Administradores',
      missingValue: 'Campo requerido',
      usernameMinimumLength: 'El nombre de usuario debe tener más de 3 caracteres',
      validUsername: 'Proporcione una dirección de nombre de usuario válida.',
      logout: 'Cerrar sesión',
      mostPopular: 'Most Popular',
      weekley: 'Favoritos semanales',
      userCard: {
        privateProfile: 'Perfil privado',
        publicProfile: 'Perfil público',
        favorite: 'favorito',
        bookmark: 'marcador',
        share: 'Cuota',
      },
      account: {
        upload: 'Cargar una nueva foto ...',
        username: "Nombre de usuario",
        mail: 'Correo electrónico',
        privateAccount: 'Mantener mi cuenta privada',
        notifications: 'Receive notifications',
        updates: 'Recibe actualizaciones sobre todos mis favoritos',
        deleteAccount: 'Borrar cuenta',
        text1: 'Visualizar',
        text2: 'tu',
        text3: 'Marcadores',
      },
      bookmarklet: {
        title: 'Agregar un marcador',
        titleRequired: 'Título requerido',
        addNewTab: 'Agregar nueva pestaña',
        addBookmark: 'Añadir marcador',
        drag: 'Arrastra este botón a la barra de marcadores.',
        install: 'Para instalar el botón "Fave It":',
        installex1: 'Muestre sus marcadores haciendo clic en Ctrl + Shift + B en su teclado',
        installex2: 'Arrastra el botón "Favorito" a la barra de marcadores.',
        installex3: 'Cuando esté navegando por la web, presione el botón "Fave It" para marcar un sitio web en su cuenta.',
      },
      login: {
        title: 'Welcome back to',
        email: 'Correo electrónico',
        username: 'Nombre de usuario',
        password: 'Contraseña',
        requiredField: 'Campo requerido.',
        minLengthUsername: 'El nombre de usuario debe tener un mínimo de 3 caracteres.',
        minLengthPassword: 'La contraseña debe tener un mínimo de 5 caracteres.',
        forgotUsername: '¿Olvidó su nombre de usuario?',
        forgotPassword: 'Forgot password?',
        loginBtn: 'Acceso',
        noAccount: "¿No tienes una cuenta?",
        getStarted: 'Empezar',
        goToLogin: 'Ir a la página de inicio de sesión',
        confirmedAccount: 'La cuenta ha sido confirmada',
      },
      faves: {
        favesByCountryTitle: 'Favoritos por país',
        hide: 'Esconder',
        show: 'Show',
        topFavesTitle: 'Top Faves',
      },
      limitPopup: {
        member: {
          title: 'Hiciste de esta página algo tuyo',
          countsTabs: '{tabs} pestañas y {sites} sitios, todos elegidos por ti.',
          countsTabsOnly: '{tabs} pestañas, todas organizadas por ti.',
          countsSites: '{sites} sitios, todos elegidos por ti.',
          countsNone: 'Todo en esta página lo elegiste tú.',
          ask: 'Nos encantaría que siga creciendo contigo. Para seguir agregando más, pedimos a los miembros de siempre como tú que apoyen AllMyFaves; es lo que lo mantiene funcionando para todos. Tu página y todo lo que contiene siguen siendo tuyos de cualquier forma.',
          cta: 'Seguir haciendo crecer mi página',
        },
        publicPage: {
          title: 'La página pública viene con un plan de pago',
          body: 'Tu página es privada, así que solo tú la ves. Con un plan de pago puedes compartirla en tu propia dirección de All My Faves, además de pestañas y sitios ilimitados, sin anuncios y prioridad de logos para los sitios que agregues.',
        },
        follow: {
          title: 'Los enlaces do-follow vienen con un plan de pago',
          body: 'Con un plan de pago, los enlaces de tu página pública transmiten autoridad de búsqueda a los sitios que enlazan. Además: pestañas y sitios ilimitados, logos para tus sitios nuevos primero y sin anuncios.',
        },
        tabFull: {
          title: 'Esta pestaña está llena: {count} sitios',
          body: 'Cada pestaña admite hasta {count} sitios para que tu página sea fácil de recorrer. Crea una pestaña nueva para el resto.',
          cta: 'Crear pestaña nueva',
        },
        price: {
          perMonth: '${amount}/mes',
          billedYearly: 'facturado anualmente',
          orMonthly: 'o ${amount} al mes',
          refund: 'reembolso completo en 14 días',
        },
        cta: 'Pásate a ilimitado',
        notNow: 'Ahora no',
        close: 'Cerrar',
        billingReason: {
          unlimited: 'Pestañas y sitios ilimitados. Elige el plan que te convenga.',
          follow: 'Enlaces do-follow, además de pestañas y sitios ilimitados. Elige el plan que te convenga.',
        },
      },
      userTopTabs: {
        addBtn: 'Agrega tus propios favoritos',
        cellTitle: 'Detalles del sitio',
        validUrl: 'Url no es válido!',
        delete: 'Eliminar',
        logo: 'logo',
        save: 'ahorrar',
        mostPopularSiteTitle: 'Agregar nuevo sitio a la lista de los más populares',
        sitetitle: 'Sitio',
        position: 'Posición',
        close: 'Cerrar',
        tabDetails: 'Detalles de la pestaña',
        private: 'privado',
        public: 'público',
        share: 'Cuota',
        copy: 'copiar link',
      },
      forgotPassword: {
        title: 'Has olvidado tu contraseña',
        forgotBtn: 'HAS OLVIDADO TU CONTRASEÑA',
      },
      resetPassword: {
        title:'Restablecer la contraseña',
        resetBtn: 'RESTABLECER LA CONTRASEÑA',
        passwordMinLength: 'La contraseña debe tener más de 8 caracteres.',
      },
      register: {
        title: 'Crea tu cuenta AllMyFaves',
        email: 'Correo electrónico',
        username: 'Nombre de usuario',
        password: 'Contraseña',
        requiredField: 'Campo requerido.',
        registerBtn: 'Crear una cuenta',
        haveAccount: '¿Tener una cuenta?',
        signInBtn: 'Registrarse',
        acceptTC: 'Acepto',
        pleaseAcceptTC: 'Acepta los términos y condiciones',
        termsConditions: 'T&C',
        visualBookmarks: 'Marcadores visuales',
        visualBookmarksTxt: 'Agregue y administre todos sus marcadores bajo un mismo techo.',
        discoverMore: 'Discover More',
        discoverMoreTxt: 'Encuentre una variedad de sitios web increíbles sobre cualquier tema.',
        faveIt: 'Fave It',
        faveItTxt: 'Guarde fácilmente sus favoritos usando el botón "Fave It".',
        everywhere: 'En todos lados',
        everywhereTxt: 'Úselo en todas partes. En cualquier computadora, teléfono inteligente o tableta.',
      },
      aboutUs: {
        eyebrow: 'About',
        pageTitle: 'Chosen by people, since 2006',
        lede: 'All My Faves is a starting page. Open a category, run your eye down it, and go \u2014 no query to phrase, no results page to read, no working out which of ten links is the one you actually meant.',

        whyTitle: 'Why search?',
        whyBody1: 'Search is good at answering a question you can already put into words. It is much worse at the other thing people do online, which is look around. Most of what you open in a day is not a question at all \u2014 it is somewhere you already know, or somewhere you would like if someone showed it to you.',
        whyBody2: 'So the site is a page of links, sorted into the categories people actually use, and every logo is one click away. That was the whole idea at the start and it has not changed since.',

        handTitle: 'Picked by hand',
        handBody1: 'Every site here was put there by a person who looked at it first. Nothing is added by a crawler and nothing is ordered by an algorithm. Some placements are paid for, and those carry a small Ad mark so you can tell which ones they are.',
        handBody2: 'Twenty years on, that is an easier case to make than it was at the beginning. A great deal of the web is now written to rank rather than to be read. A short list someone stands behind is worth more than a long one nobody checked.',

        storyTitle: 'Where it came from',
        storyBody1: 'In 2006 Shachar Pessis got tired of how much work it took to get anywhere online \u2014 typing addresses from memory, digging through a bookmark list that had long since stopped being useful, or asking whichever friend happened to know the good sites.',
        storyBody2: 'He said as much to his brother Roy, and between them they sketched out what became All My Faves: one page of the sites people actually use, arranged so you could find something without already knowing its name. It has been put together by hand ever since.',

        yoursTitle: 'Make it your own',
        yoursBody: 'My Faves gives you your own version of the page \u2014 your sites, your categories, in the order you want them, waiting in any browser you sign in to.',
        yoursLink: 'Start your own page',

        latestTitle: 'The Latest',
        latestBody: 'The row at the top of the homepage holds the newest sites to pass review. Nothing that has been featured is thrown away when the next batch arrives \u2014 it all stays in the archive.',
        latestLink: 'Browse the archive',

        nextTitle: 'Anything else?',
        faqCard: 'Frequently asked questions',
        faqCardBody: 'How the page works, accounts, and what to do when something breaks.',
        contactCard: 'Contact us',
        contactCardBody: 'Feedback, a broken link, a correction, or a partnership.',
        advertiseCard: 'Advertise with us',
        advertiseCardBody: 'Take a position in any category on the homepage.',
      },
      press: {
        pressPageTitle: 'Press Room'
      },
      bookmark: {
        faveBookmarkPageTitle: 'El marcador',
        saveBookmark: 'Guarda fácilmente tus favoritos',
      },
      contact: {
        title: 'Contacta con nosotros',
        subtitle1: 'Tu opinión significa mucho para nosotros. Si tiene un comentario, sugerencia, queja o recomendación de un sitio / categoría, envíenos un correo electrónico a',
        subtitle2: 'o complete el formulario a continuación.',
        checkboxTitle: '¿Cómo te enteraste de nosotros?',
        checkbox: {
          search: 'Search',
          referringSite: 'Reffering Site',
          tv: 'Television',
          radio: 'Radio',
          newspaper: 'Newspaper',
          world: 'World Of Mouth'
        },
      },
      footer: {
        titleSection1: 'Todos mis favoritos',
        aboutUs: 'Sobre nosotros',
        advertise: 'Anúnciate con nosotros',
        join: 'Entrar',
        tellAFriend: 'Dile a un amigo',
        press: 'prensa',
        blog: 'Blog',
        adminArea: "Área de administración",
        support: 'Apoyo',
        faq: 'FAQ',
        wantMore: '¿Quieren más?',
        contactUs: 'Contacta con nosotros',
        oldWebsite: 'Old Website',
        downloadApp: "Download the App",
        privacy: 'Privacy Policy',
        terms: 'Condiciones de uso',
        rights: 'Reservados todos los derechos.',
      },
      navbar: {
        topFaves: 'Top Favoritos',
        shop: 'Tienda',
        shopping: 'Compras',
        apparel: 'Vestir',
        homeElectronics: 'Hogar y electrónica',
        discover: 'Descubrir',
        weeklyFaves: 'Favoritos Semanales',
        weeklyGames: 'Juegos Semanales',
        favesByCountry: 'Favoritos por país',
        blog: 'Blog',
        settings: 'Ajustes',
        myFaves: 'Mis favoritos',
        interests: 'Agregar intereses',
        faveButton: 'Botón Fave It',
        faq: 'FAQ',
        sideBarHome: 'Navegación',
        home: 'Hogar',
        profile: 'Perfil',
        adminMenu: 'Menú de administración',
      },
    },
  },
});

export default i18n;
